import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

export class Spinner extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    return h.div(h.ca(styles.spinner),
      h.div(h.ca(styles.spinnerArc)))
  }
}

export class NoResults extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    return h.div(h.ca(styles.noResults),
      'Sorry, there weren\'t any results. Try adjusting your search.')
  }
}

export default class ResultsIndicator extends Component {
  static defaultProps = {
    showProgress: false,
    hasResults: false
  }

  render () {
    const { showProgress, hasResults } = this.props

    return h.div(h.ca(styles.resultsIndicator),
      h.maybe(showProgress, h.h(Spinner)),
      h.maybe(!hasResults && !showProgress,
        h.h(NoResults)))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ResultsIndicator/index.js